import { QueryClient } from 'react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // treat query responses as fresh for 5 minutes
      staleTime: 5 * 60 * 1000,
    },
  },
});
